export default __webpack_public_path__ + "static/media/404-page-bg.c5ebd6ff.png";